// GENERATED from consumables.store by tools/consumables-store.js — do not edit.
// Edit the store (or the knobs app Consumables tab), then re-run the generator
// (`node tools/consumables-store.js`). The store is the single source of
// truth; this module is its projection shared/src/consumables.ts imports
// (the pocket's use resolution, the loot table's consumable references).
// Rows are typed ConsumableDataRow (shared/consumables.ts): a projection
// missing a required field is a typecheck error; the catalog's
// load-time throw still catches value errors the type can't see.
import type { ConsumableDataRow } from "./consumables.js";

export const CONSUMABLES_DATA: readonly ConsumableDataRow[] = [
  {
    "id": 0,
    "name": "Bandage",
    "icon": "bandage-ff2600",
    "shade": "#ff2600",
    "type": "heal",
    "amount": 10,
    "buffType": null,
    "magnitude": null,
    "duration": null,
  },
  {
    "id": 1,
    "name": "Potion of Power",
    "icon": "potion-00fcff",
    "shade": "#00fcff",
    "type": "buff",
    "amount": null,
    "buffType": "damage",
    "magnitude": 110,
    "duration": 1000,
  },
  {
    "id": 2,
    "name": "Restorative Bandage",
    "icon": "bandage-932092",
    "shade": "#932092",
    "type": "heal",
    "amount": 30,
    "buffType": null,
    "magnitude": null,
    "duration": null,
  },
  {
    "id": 3,
    "name": "Regenerative bandage",
    "icon": "bandage-00f900",
    "shade": "#00f900",
    "type": "heal",
    "amount": 60,
    "buffType": null,
    "magnitude": null,
    "duration": null,
  },
  {
    "id": 4,
    "name": "Potion of Potent Power",
    "icon": "potion-521b92",
    "shade": "#521b92",
    "type": "buff",
    "amount": null,
    "buffType": "damage",
    "magnitude": 125,
    "duration": 1000,
  },
  {
    "id": 5,
    "name": "Potion of Accuracy",
    "icon": "potion-feffff",
    "shade": "#feffff",
    "type": "buff",
    "amount": null,
    "buffType": "accuracy",
    "magnitude": 110,
    "duration": 1000,
  },
  {
    "id": 6,
    "name": "Potion of Speed",
    "icon": "potion-ffd478",
    "shade": "#ffd478",
    "type": "buff",
    "amount": null,
    "buffType": "speed",
    "magnitude": 150,
    "duration": 500,
  },
  {
    "id": 7,
    "name": "Potion of Soak",
    "icon": "potion-000000",
    "shade": "#000000",
    "type": "buff",
    "amount": null,
    "buffType": "damage_taken",
    "magnitude": 90,
    "duration": 500,
  },
];
